import { http } from '@/untils/request'
import { history } from '@/router/history'
import store from '@/store/index'
const { playStore, generalStore, sheetStore } = store

export const commonObj = {
  staticBaseUrl: 'https://www.mrzhj.cn/static/music/'
}

/**
 * @description 判断环境
 * @returns {string} 'dev' 开发环境 'prod' 生产环境
 */
const judgeEnv = () => {
  const arr = ['192.168.0.1', 'localhost', '127.0.0.1']
  const host = window.location.host
  const flag = arr.filter(item => host.includes(item))
  // console.log(flag)
  // console.log(host)
  if (flag.length) {
    console.log('开发环境')
    // return 'dev'
    return 'prod'
  } else {
    console.log('生产环境')
    return 'prod'
  }
}

const apiUlr = judgeEnv() === 'dev' ? 'http://127.0.0.1:3003' : 'https://musicserver.mrzhj.cn'
/**
 * api请求相关数据
 */
export const apiObj = { url: apiUlr }

/**
 * 数组对象去重
 * @param {Array} val1 数组
 * @param {string} val2 唯一标识字段（不传表示是基本数组，传了表示是对象数组）
 */
function distinctArr(val1, val2) {
  if (!(val1 instanceof Array)) {
    alert('传入数据不是个数组')
    return
  }
  let arr = []
  if (!val2) {
    arr = [...new Set(val1)]
  } else {
    let obj = {}
    arr = val1.reduce((pre, item) => {
      if (!obj[item[val2]]) {
        obj[item[val2]] = true
        return [...pre, item]
      } else {
        return pre
      }
    }, [])
  }
  return arr
}

/**
 * @name timerFormat
 * @desc 时间格式化（支持时分秒一起或单独返回）
 * @param {number} val1 需要格式化的时间（单位：s）
 * @param {string} val2 是否携带小时的标志
 * @returns {string} 格式化后的时间
 */
export function timerFormat(val1, val2) {
  let num = parseInt(val1 / 1000) // 一共多少秒
  var t = '' //
  if (num <= 0) {
    // console.log("时间错误")
    return '00:00'
  }
  var hour = Math.floor(num / 3600)
  var min = Math.floor(num / 60) % 60
  var sec = num % 60
  if (val2 === 'h') {
    if (hour < 10) {
      t = '0' + hour + ':'
    } else {
      t = hour + ':'
    }
  }
  if (min < 10) {
    t += '0'
  }
  t += min + ':'
  if (sec < 10) {
    t += '0'
  }
  t += sec
  return t
}

/**
 * 时间戳转换为时间
 * @param {string} val1 时间戳
 * @param {boolean} val2 是否携带时分秒
 * @returns {string} 格式化后的时间
 */
export function timerChange(val1, val2) {
  let t = new Date(val1).toLocaleString()
  let i = t.indexOf(' ')
  if (!val2) return t.substring(0, i)
  else return t
}

/**
 * 获取歌曲地址
 * 需要变为同步操作
 * 音乐地址并不是一成不变的
 * @param {string} val1 歌曲id
 * @param {any} val2 随便什么主要用于同步歌曲地址，因为地址一直在变化，长时间不更改歌曲，歌曲一变化播放就会报错
 */
export function getMusicUrl(val1, val2) {
  return new Promise((resolve, reject) => {
    http('get', '/song/url', { id: val1, level: 'standard' }).then(res => {
      // console.log(res)
      if (val2) {
        setPlyObj(res.data[0].url)
        resolve('这个resolve无意义不用管')
      } else {
        resolve(res.data[0].url)
      }
    })
  })
}

/**
 * 设置store中的playObj
 * 之所以单独一个方法是因为playMusic做了节流的控制
 * @param {string | object} val 前者表示是歌曲地址，后者表示是歌曲对象
 */
function setPlyObj(val) {
  if (!val) return
  if (typeof val == 'string') {
    playStore.playObj.url = val
  } else {
    for (let item in playStore.playObj) {
      playStore.playObj[item] = val[item]
    }
  }
}

let spin = false
/**
 * @name playMusic
 * @desc 中间obj做的判断操作是因为如果是音乐播放列表中的数据都是已经做过操作的数据
 * @param {object} val 音乐对象
 * @ps flag是节流字段
 */
export async function playMusic(val) {
  console.log(val)
  if (spin || val.id === playStore.playObj.id) return
  spin = true
  const obj = {
    id: val.id,
    picUrl: val.al ? val.al.picUrl : val.picUrl,
    name: val.name,
    siname: val.al ? val.al.name : val.siname,
    sinameId: val.al ? val.al.id : val.sinameId,
    singer: val.ar ? [...val.ar] : val.singer,
    dt: val.dt,
    url: '',
    fee: val.fee
  }
  obj.url = await getMusicUrl(val.id)
  setPlyObj(obj)
  spin = false
}

/**
 * 添加到播放列表
 * @param {array | object} val1 多个或单个（是object的时候val2就可以不传）
 * @param {string} val2 1添加还是2覆盖(非必选)
 */
export async function addPlayList(val1, val2) {
  if (val1 instanceof Array) {
    let arr = val1.map(item => {
      const obj = {
        id: item.id,
        picUrl: item.al.picUrl,
        name: item.name,
        siname: item.al.name,
        sinameId: item.al.id,
        singer: [...item.ar],
        dt: item.dt,
        fee: item.fee
        // url: ""
      }
      return obj
    })
    if (val2 === 1) {
      console.log([...playStore.pbList, ...arr])
      playStore.pbList = distinctArr([...playStore.pbList, ...arr], 'id')
    } else if (val2 === 2) {
      playStore.pbList = arr
    }
  } else {
    const obj = {
      id: val1.id,
      picUrl: val1.al.picUrl,
      name: val1.name,
      siname: val1.al.name,
      sinameId: val1.al.id,
      singer: [...val1.ar],
      dt: val1.dt,
      fee: val1.fee
      // url: ""
    }
    let index = playStore.pbList.findIndex(item => item.id === obj.id)
    if (index === -1) {
      // let arr = [obj, ...playStore.pbList]
      // playStore.pbList = arr
      playStore.pbList.unshift(obj)
    }
  }
}

/**
 * 新建或添加到歌单
 * @param {boolean} val1 弹出框标志
 * @param {string} val2 添加或者创建
 * @param {object} val3 需要添加的对象（添加操作才有）
 */
export function toggleSongSheet(val1, val2, val3) {
  // console.log(typeof val1)
  if (!val1) {
    generalStore.sheetModal.flag = false
    return
  } else {
    generalStore.sheetModal.flag = true
  }
  generalStore.sheetModal.action = val2
  if (val2 === 'create') return
  generalStore.sheetModal.obj = val3
}

/**
 * 添加到我的歌单
 * @param {object} val 歌单对象
 */
export function addMySheet(val) {
  // console.log(val)
  // console.log(sheetStore.sheetList)
  // console.log(generalStore.sheetModal.obj)
  let index = sheetStore.sheetList.findIndex(item => item.name === val.name)
  let idx = sheetStore.sheetList[index].list.findIndex(
    item => item.id === generalStore.sheetModal.obj.id
  )
  // console.log(obj)
  if (idx > -1) {
    return { type: 'warning', msg: '歌曲已存在' }
  } else {
    sheetStore.sheetList[index].list.unshift(generalStore.sheetModal.obj)
    toggleSongSheet(false)
    return { type: 'success', msg: '添加成功' }
  }
}

/**
 * 下载歌曲
 * @param {object} val 歌曲对象
 * @flag 控制节流
 */
let flag = true
export async function downloadMusic(val) {
  if (!flag) return
  flag = false
  let url = await getMusicUrl(val.id)
  fetch(url)
    .then(res => res.blob())
    .then(blob => {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.style.display = 'none'
      // 使用获取到的blob对象创建的url
      const str = window.URL.createObjectURL(blob)
      a.href = str
      // 指定下载的文件名
      a.download = `${val.name}.mp3`
      a.click()
      document.body.removeChild(a)
      flag = true
      // 移除blob对象的url
      window.URL.revokeObjectURL(str)
    })
}

/**
 * 路由跳转
 * @param {string} val1 需要跳转的路由名
 * @param {number} val2 id
 * @param {string} val3 首页榜单字段、或视频详情类型字段
 */
export function jumpRouter(val1, val2, val3) {
  switch (val1) {
    case 'song': // 歌曲
      // })
      // history.push({
      //   pathname: "/songDetail",
      //   query: {
      //     songId: val2
      //   }
      // })
      history.push(`/songDetail?songId=${val2}`)
      // window.location.href = `/songDetail?songId=${val2}`
      break
    case 'siname': // 专辑
      history.push(`/sinameDetail?sinameId=${val2}`)
      // window.location.href = `/sinameDetail?sinameId=${val2}`
      return
    case 'singer': // 歌手(有些歌手id是0，没牌面-.-)
      if (!val2) return
      history.push(`/singerDetail?singerId=${val2}`)
      // window.location.href = `/singerDetail?singerId=${val2}`
      return
    case 'sheet': // 歌单
      let href = `/sheetDetail?sheetId=${val2}`
      if (val3) href = href + '&type=rank'
      history.push(href)
      // window.location.href = href
      return
    case 'video': // 歌单
      //val3 0是MV，1是视频
      history.push(`/videoDetail?videoId=${val2}&type=${val3}`)
      // window.location.href = `/videoDetail?videoId=${val2}&type=${val3}`
      return
    default:
      return
  }
}